import Model from './model.js';

export default class FileInfo extends Model {
  constructor(id = 0, path = '', type = '', size = 0, description = '', binaryFile = null) {
      super();
      this.id = id ?? 0;
      this.path = path ?? '';
      this.type = type ?? '';
      this.size = size ?? 0;
      this.description = description ?? '';
      this.binaryFile = binaryFile ?? null;

      this.init();
    }

    filePath() {
      return this.path ?? "";
    }

    hasFilePath() {
      return typeof this.filePath() === "string" && this.filePath().trim().length > 0;
    }
}
